import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import ApiIcon from "@mui/icons-material/Api";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { menu } from "./menu";
import { MenuList } from "./MenuList";
import { Divider, Button, Stack } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logos/fa_logo.png";

const NavigationVertical = (props) => {
    const { userData, ...other } = props;
    const [selectedIndex, setSelectedIndex] = useState("1");
    const [selectedItem, setSelectedItem] = useState();
    const handleClick = (event) => {
        let path = event.target.id;
        window.open("/" + path, "_self");
    };

    const handleSignoutClick = (event) => {
        window.open("/" + "signout", "_self");
    };

    const handleSelected = (selected) => {
        setSelectedIndex(selected?.id);
    };
    return (
        <Drawer variant="permanent" {...other}>
            <Grid
                disablePadding
                container
                spacing={0.5}
                sx={{
                    position: "relative",
                    padding: "6px 0px 0px 22px",
                }}>
                <Grid sx item>
                    <Box component="div" wordWrap="break-word !important" width={"80%"} lineHeight={"1.37"}>
                        <Box
                            component="img"
                            src={logo}
                            alt="Logo"
                            sx={{ width: "200px", mr: "0px", mb: "20px", mt: "20px" }}
                        />
                    </Box>
                </Grid>
            </Grid>
            <Divider sx={{ borderColor: "#2D3843" }} />
            <Box
                sx={{
                    height: "90%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                }}>
                <Box sx={{ ml: 1, mt: 2 }}>
                    {menu.map((item, index) => (
                        <MenuList
                            key={item?.id}
                            item={item}
                            onSelection={handleSelected}
                            selectedIndex={selectedIndex}
                            selectedItem={selectedItem}
                        />
                    ))}
                </Box>
                <Box
                    sx={{
                        px: 1,
                        textAlign: "center",
                    }}>
                    <Box>
                        <Button
                            fullWidth
                            sx={{ cursor: "pointer" }}
                            size="large"
                            variant="contained"
                            onClick={(e) => handleClick(e)}
                            id="donationOrder">
                            Start new project
                        </Button>
                    </Box>

                    <Button
                        variant="outlined"
                        onClick={(e) => handleSignoutClick(e)}
                        color="error"
                        fullWidth
                        sx={{ mt: "10px", cursor: "pointer" }}>
                        Sign out
                    </Button>
                    <Divider sx={{ mt: 2, borderColor: "#2D3843" }} />
                    <Box
                        sx={{
                            p: 2,
                            height: "8dvh",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}>
                        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                            <Stack direction={"column"} spacing={0.5}>
                                <Typography variant="subtitle1" textTransform={"capitalize"}>
                                    {userData?.contact?.name}
                                </Typography>
                                <Typography variant="body1" sx={{ textAlign: "left" }} color={"text.secondary"}>
                                    {" "}
                                    {userData?.contact?.accountName}
                                </Typography>
                            </Stack>
                            <Stack direction={"column"} spacing={0.5}></Stack>
                        </Stack>
                    </Box>
                </Box>
            </Box>
        </Drawer>
    );
};

export { NavigationVertical };
